import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAuth } from '@/hooks/useAuth';
import { useGetAgent } from '@/hooks/useAgent';

const InputForm = ({ onFormChange, initialData }) => {
  const intl = useIntl();
  const [formData, setFormData] = useState({
    name: '',
    introduction: '',
    greeting: ''
  });
  const [isInitialized, setIsInitialized] = useState(false);

  const {userData} = useAuth()
  const { data: agent, isLoading } = useGetAgent(userData?.uID);

  // Fill formData từ agent?.data một lần duy nhất khi vào page
  useEffect(() => {
    if (agent?.data && !isInitialized) {
      const newData = {
        name: agent.data.name || '',
        introduction: agent.data.introduction || '',
        greeting: agent.data.greeting || ''
      };
      setFormData(newData);
      setIsInitialized(true);
      onFormChange?.(newData);
    }
  }, [agent, isInitialized]);

  // Reset formData khi initialData đổi (sau khi save)
  useEffect(() => {
    if (initialData && JSON.stringify(initialData) !== JSON.stringify(formData)) {
      setFormData(initialData);
    }
  }, [initialData]);

  const handleChange = (field, value) => {
    const newData = { ...formData, [field]: value };
    setFormData(newData);
    onFormChange?.(newData);
  };

  return (
    <>
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1"><FormattedMessage id="AGENTS.HOME.NAME" /></label>
        <input
          className="w-full border rounded px-3 py-2 bg-white text-sm  focus:border-[#50B553] outline-none"
          placeholder={intl.formatMessage({ id: "AGENTS.HOME.NAME_PLACEHOLDER" })}
          value={formData.name}
          onChange={e => handleChange('name', e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1"><FormattedMessage id="AGENTS.HOME.INTRODUCTION" /></label>
        <textarea 
          className="w-full border rounded px-3 py-2 bg-white text-sm focus:border-[#50B553] outline-none" 
          rows={2}
          placeholder={intl.formatMessage({ id: "AGENTS.HOME.INTRODUCTION_PLACEHOLDER" })}
          value={formData.introduction}
          onChange={(e) => handleChange('introduction', e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1"><FormattedMessage id="AGENTS.HOME.GREETING" /></label>
        <textarea 
          className="w-full border rounded px-3 py-2 bg-white text-sm focus:border-[#50B553] outline-none" 
          rows={2}
          placeholder={intl.formatMessage({ id: "AGENTS.HOME.GREETING_PLACEHOLDER" })}
          value={formData.greeting}
          onChange={(e) => handleChange('greeting', e.target.value)}
        />
      </div>
    </>
  );
};

export { InputForm };
